import { EntitySwitch, isKind } from '@backstage/plugin-catalog';

import { DefaultEntityPage } from './default';
import { ComponentEntityPage } from './component';
import { DomainPage } from './domain';
import { SystemPage } from './system';
import { APIPage } from './api';
import { UserPage } from './user';
import { GroupPage } from './group';

export default (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')}>{ComponentEntityPage}</EntitySwitch.Case>

    <EntitySwitch.Case if={isKind('api')}>{APIPage}</EntitySwitch.Case>

    <EntitySwitch.Case if={isKind('group')}>{GroupPage}</EntitySwitch.Case>

    <EntitySwitch.Case if={isKind('user')}>{UserPage}</EntitySwitch.Case>

    <EntitySwitch.Case if={isKind('system')}>{SystemPage}</EntitySwitch.Case>

    <EntitySwitch.Case if={isKind('domain')}>{DomainPage}</EntitySwitch.Case>

    <EntitySwitch.Case>{DefaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
